import axios from 'axios'
import { host } from '../../../helper/config'
import { FULL_LIST_ITEM_PER_PAGE, getItemPerPage } from '../../../helper/helper'

const PLUGINS_NAME = 'admin-loto-carts'

export const updateCartStatus = async (token, cartId, status) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/update-cart-status`, {
        cartId,
        status,
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}

export const getListGroupedFull = async (token, query, page) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-list-cart-grouped-full`, {
        ...query,
        page: page,
        itemPerPage: getItemPerPage()
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}

export const getListGrouped = async (token, page, itemPerPage) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-list-cart-grouped`, {
        page: page,
        itemPerPage: itemPerPage
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}

export const getList = async (token, query, page) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-list-cart`, {
        ...query,
        page: page,
        itemPerPage: getItemPerPage()
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}

export const getSummary = async (token, query, page) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-summary-cart`, {
        ...query,
        page: page,
        itemPerPage: getItemPerPage()
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}

export const getUploadStatistic = async (token, query) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-upload-statistic`, {
        ...query,
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}

export const getTabStatistic = async (token, query) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-tab-statistic`, {
        ...query,
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}

export const getCsv = async (token, query, page) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-csv-cart`, {
        ...query,
        page: page,
        itemPerPage: FULL_LIST_ITEM_PER_PAGE
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}

export const getTicketResultDetail = async (token, ticketId) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-ticket-result-detail`, {
        ticketId,
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}
